import type { ClassNameProps } from "../types";
import { cn } from "../utils";

/** Props Interface */
interface OverlayProps extends ClassNameProps {
	/** Omitted where the overlay's owner dismisses on its own outside-click handling. */
	onClick?: () => void;
	opacity?: number;
}

export function Overlay({ opacity = 0.9, className, ...props }: OverlayProps) {
	/** Render */
	return (
		<div
			aria-hidden="true"
			className={cn("z-10 fixed inset-0 bg-black dark:bg-black cursor-pointer", className)}
			onClick={props.onClick}
			style={{ opacity }}
		/>
	);
}
